module.exports = __webpack_public_path__ + "static/media/day-cloud-rain-lightning-icon.1dc5c3a9.svg";